import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import NotificationBannerSkeleton from './NotificationBannerSkeleton';
const UserOrdersProtectionPlanBanner = t0 => {
  const $ = _c(3);
  const {
    planName,
    productName
  } = t0;
  let t1;
  if ($[0] !== planName || $[1] !== productName) {
    t1 = <NotificationBannerSkeleton title=" Congrats! Your Protection Plan has been confirmed." body={<>{planName} has been applied to your {productName}.</>} />;
    $[0] = planName;
    $[1] = productName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
UserOrdersProtectionPlanBanner.propTypes = {
  planName: PropTypes.string,
  productName: PropTypes.string
};
export default UserOrdersProtectionPlanBanner;